import { Promise as bbPromise } from 'bluebird';
import { notifySuccess, notifyError } from './common';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

export const defaultState = {
    entityName: 'users',
    baseUrl: 'api/users/',
    tableName: 'usersTable',
    ...baseState,
    helpUrl: '/user-guide/guide/users.html'
};

export const mutations = {
    ...baseMutations
};

export const actions = {
    ...baseActions,
    fetchUsers({ commit, dispatch, state }, { searchParams, filterParams }) {
        console.log('calling fetchUsers', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams,
            notifyConfig,
            saveParams: true,
            isDsSearch: false
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    setVenueFilters({ commit, state, rootState }) {
        console.log('calling setVenueFilters');
        const { selectedVenue } = rootState.venue;
        const venueFilters = {
            mso: selectedVenue.mso.identifier,
            partner: selectedVenue.partner.identifier,
            venue: selectedVenue.venue.identifier
        };
        commit('setFiltersConfig', {
            ...state.filtersConfig,
            ...venueFilters
        });
        commit('setFilterQuery', {
            ...state.filterQuery,
            ...venueFilters
        });
    },
    postBulkActions({ dispatch }, { action, criteria, params }) {
        console.log('calling postBulkActions', action, criteria, params);
        if (action === 'delete') {
            return dispatch('bulkDelete', { userIds: criteria.ids });
        }
    },
    async bulkDelete({ dispatch }, { userIds }) {
        dispatch('notifier/requestPending', null, { root: true });
        const successMessage = 'Bulk delete was executed successfully.';
        const failMessage =
            'Error occured while executing a bulk delete on users';
        const deleteNotifyConfig = {
            notifyRequestPending: false,
            notifySuccess: false,
            notifyError: false
        };
        return bbPromise
            .each(userIds, id => {
                return dispatch(
                    'user/deleteUser',
                    { userId: id, notifyConfig: deleteNotifyConfig },
                    { root: true }
                );
            })
            .then(() => {
                notifySuccess(dispatch, successMessage);
            })
            .catch(error => {
                notifyError(dispatch, failMessage, error);
            });
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
